import * as bootstrap from 'bootstrap';

// empties the job details when a route is clicked to reset tertiary content
const dashboardRouteClick = () => document.querySelector('#job').innerHTML = '';
const jobHighlight = (el) => {
  document.querySelectorAll('#route_stops a[data-turbo-frame="job"]').forEach((stopEl) => {
    const highlightableEl = stopEl.querySelector('.js-highlightable');
    if (el.currentTarget === stopEl) {
      highlightableEl.classList.add('active');
    } else {
      highlightableEl.classList.remove('active');
    }
  });
}
const routeHighlight = (el) => {
  document.querySelectorAll('#routes a[data-turbo-frame="route_stops"]').forEach((routeEl) => {
    const highlightableEl = routeEl.querySelector('.js-highlightable');
    if (el.currentTarget === routeEl) {
      highlightableEl.classList.add('active');
    } else {
      highlightableEl.classList.remove('active');
    }
  });
}
const eventHighlight = (el) => {
  document.querySelectorAll('#events a[data-turbo-frame="event"]').forEach((eventEl) => {
    const highlightableEl = eventEl.querySelector('.js-highlightable');
    if (el.currentTarget === eventEl) {
      highlightableEl.classList.add('active');
    } else {
      highlightableEl.classList.remove('active');
    }
  });
}
const popoverElements = () => {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popoverTriggerEl) => {
    new bootstrap.Popover(popoverTriggerEl);
  });
}

document.addEventListener('turbo:load', () => {
  // console.log('callback');
  popoverElements();

  document.querySelectorAll('a[data-turbo-frame="route_stops"]').forEach((dashboardRouteEl) => {
    dashboardRouteEl.addEventListener('click', dashboardRouteClick);
    dashboardRouteEl.addEventListener('beforeunload', dashboardRouteClick);
    dashboardRouteEl.addEventListener('click', routeHighlight);
    dashboardRouteEl.addEventListener('beforeunload', routeHighlight);
  });

  document.querySelectorAll('a[data-turbo-frame="event"]').forEach((dashboardEventEl) => {
    dashboardEventEl.addEventListener('click', eventHighlight);
    dashboardEventEl.addEventListener('beforeunload', eventHighlight);
  });

  // attaches the jobHighlight function to all job elements loaded into the route turbo-frame
  document.addEventListener('turbo:frame-render', (load) => {
    load.currentTarget.querySelectorAll('a[data-turbo-frame="job"]').forEach((dashboardJobEl) => {
      dashboardJobEl.addEventListener('click', jobHighlight);
      dashboardJobEl.addEventListener('beforeunload', jobHighlight);
    });
    // initialize any loaded popovers
    popoverElements();
  });
});
